import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook to manage the disclaimer dialog logic
 * Handles checking if the user has previously acknowledged the disclaimer
 * and provides methods to show/hide the dialog
 */
export function useDisclaimer() {
  const [requireDisclaimerAcknowledgment, setRequireDisclaimerAcknowledgment] = useState<boolean>(false);
  const [disclaimerDialogOpen, setDisclaimerDialogOpen] = useState<boolean>(false);
  
  // Check for disclaimer acknowledgment on mount
  useEffect(() => {
    // Check if user has acknowledged disclaimer
    const hasAcknowledged = localStorage.getItem('tideAnalyzer.disclaimerAcknowledged') === 'true';

    if (!hasAcknowledged) {
      setRequireDisclaimerAcknowledgment(true);
      setDisclaimerDialogOpen(true);
    }
  }, []);
  
  // Handle disclaimer dialog open
  const handleShowDisclaimer = useCallback(() => {
    setRequireDisclaimerAcknowledgment(false);
    setDisclaimerDialogOpen(true);
  }, []);

  // Handle disclaimer dialog close
  const handleCloseDisclaimerDialog = useCallback(() => {
    setDisclaimerDialogOpen(false);
  }, []);
  
  return {
    requireDisclaimerAcknowledgment,
    disclaimerDialogOpen,
    handleShowDisclaimer,
    handleCloseDisclaimerDialog,
    setDisclaimerDialogOpen
  };
}
